import { useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import useUpdateStatutorydoc from "../../lib/updateUpdateStatDocs";
import { ReactComponent as UploadIcon } from "../../../Asset/upload-cloud-02.svg";
import { ReactComponent as AddIcon } from "../../../Asset/add-circle.svg";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";
import { CiFileOn } from "react-icons/ci";
import { ToastContainer } from "react-toastify";
import Spinner from "../../../Utils/spinner/loading";
import { ReactComponent as BlackVatugIcon } from "../../../Asset/black.svg";
import "./updatedocs.css";

const UpdateDocs = () => {
  const navigate = useNavigate();
  const { handleSubmit, loading, error, success } = useUpdateStatutorydoc();
  const [formData, setFormData] = useState([]);
  const allowedDocuments = ["businessRegistration", "financialStatement", "companyProfile", "itf", "nitf"];

  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    const newFormData = [...formData];
    newFormData[index] = {
      ...newFormData[index],
      file: file,
    };
    setFormData(newFormData);
  };

  const handleNameChange = (e, index) => {
    const newName = e.target.value;
    const newFormData = [...formData];
    newFormData[index] = {
      name: newName,
      file: newFormData[index]?.file || null,
    };
    setFormData(newFormData);
  };

  const addDocumentField = () => {
    setFormData([...formData, { name: "", file: null }]);
  };

  const removeDocument = (index) => {
    const newFormData = [...formData];
    newFormData.splice(index, 1);
    setFormData(newFormData);
  };

  const handleFinish = (e) => {
    e.preventDefault();
    handleSubmit(e, formData);
  };

  const formatFileSize = (size) => {
    if (size >= 1000000) {
      return (size / 1000000).toFixed(2) + " MB";
    } else if (size >= 1000) {
      return (size / 1000).toFixed(2) + " KB";
    } else {
      return size + " bytes";
    }
  };

  const capitalizeInitial = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getAvailableOptions = (currentIndex) => {
    const selectedNames = formData
      .filter((_, index) => index !== currentIndex)
      .map((item) => item.name);
    return allowedDocuments.filter(
      (doc) => !selectedNames.includes(doc) || doc === formData[currentIndex]?.name
    );
  };

  return (
    <Fragment>
      <ToastContainer/>
    <div className="update-docs-container">
      <div className="wrap">

     
      <div className="header">
        <button onClick={() => navigate("/typeofupdate")}>Back</button>
        <BlackVatugIcon onClick={() => navigate("/")}/>
        <button className="finished" onClick={handleFinish} disabled={loading}>
          {loading ? <Spinner /> : "Finish"}
        </button>
      </div>
      <form>
        <h2>Update Statutory Documents</h2>
        {formData.map((item, index) => (
          <div key={index} className="card">
            <select
              value={item.name}
              onChange={(e) => handleNameChange(e, index)}
            >
              <option value="">Select name of document</option>
              {getAvailableOptions(index).map((doc) => (
                <option key={doc} value={doc}>
                  {capitalizeInitial(doc.replace(/([A-Z])/g, " $1"))}
                </option>
              ))}
            </select>
            {!item.file && (
              <label>
                Document
                <span>
                  <input
                    type="file"
                    hidden
                    accept="application/pdf"
                    onChange={(e) => handleFileChange(e, index)}
                  />
                  <>
                    <UploadIcon />
                    <p>
                      Drop pdf here, <span>or browse</span>
                    </p>
                    <h5>Supports: PDF</h5>
                  </>
                </span>
              </label>
            )}
            {item.file && (
              <div className="uploaded">
                <div className="wrap">
                  <CiFileOn className="file" />
                  <div className="in">
                    <span>
                      <h3>{capitalizeInitial(item.name.replace(/([A-Z])/g, " $1"))}</h3>
                      {/* <p>{item.file.name}</p> */}
                    </span>
                    <p>{formatFileSize(item.file.size)} - 100% Uploaded</p>
                  </div>
                </div>
                <div className="last">
                  <IoCheckmarkDoneCircleOutline className="mark" />
                  <RiDeleteBin5Line
                    onClick={() => removeDocument(index)}
                    className="delete"
                  />
                </div>
              </div>
            )}
          </div>
        ))}

        <span type="button" onClick={addDocumentField}>
          <AddIcon />
          {formData.length > 0 ? "Add More Document" : "Add Document"}
        </span>

        {
          formData.length > 0 && (
            <button className="finished" onClick={handleFinish} disabled={loading}>
          {loading ? <Spinner /> : "Finish"}
        </button>
          )
        }

        {error && (
          <p style={{ margin: "auto", color: "red", fontFamily: "Montserrat" }}>
            {error}
          </p>
        )}
        {success && (
          <p
            style={{ margin: "auto", color: "green", fontFamily: "Montserrat" }}
          >
            {success}
          </p>
        )}
      </form>
      </div>
    </div>
    </Fragment>
  );
};

export default UpdateDocs;

